import React      from 'react';
import ModalStore from '@widesk-ui/stores/modalStore';

type ModalContextType = { modalStore?: ModalStore; }

const ModalContext = React.createContext<ModalContextType>({ modalStore: undefined });

export default ModalContext;
